<template>
  <VMultiModal :showing="showing" data-intercom-target="import-slides-modal">
    <EditorDeckModalsDeckSelector
      v-show="showing && step === STEPS.CHOOSE_DECK"
      :key="showing.toString()"
      :deck-id="deck.id"
      :showing="showing"
      :company-id="deck.company_id"
      :is-exporting="false"
      :loading="state.loading"
      data-testid="deck-selector"
      @select-deck="selectDeck"
      @close="$emit('update:showing', false)"
      @cancel="$emit('update:showing', false)"
    >
      <template #header>
        <VModalHeader>
          <template #title>Choose a 3D Presentation</template>
          <template #sub-title>Import slides from another 3D Presentation</template>
        </VModalHeader>
      </template>
      <div />
    </EditorDeckModalsDeckSelector>

    <EditorDeckModalsDeckSlideSelector
      v-if="showing && step === STEPS.CHOOSE_SLIDES && state.selectedDeck"
      :key="`${state.selectedDeck.id}-${STEPS.CHOOSE_SLIDES}`"
      :showing="showing"
      :selected-deck="state.selectedDeck"
      data-testid="deck-slide-selector"
      @copy-slides="copySlides"
      @close="$emit('update:showing', false)"
      @back="step = STEPS.CHOOSE_DECK"
    />
  </VMultiModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { reactive, ref, watch } from 'vue'

import type { Slide } from '@/entities/deck'
import type { EditDeck } from '@/composables/useEditDeck'

enum STEPS {
  CHOOSE_DECK,
  CHOOSE_SLIDES,
}

const props = defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  showing: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['copy-slides', 'update:showing'])

const step = ref<STEPS>(STEPS.CHOOSE_DECK)
const state = reactive({
  selectedDeck: null as EditDeck | null,
  loading: false,
})

watch(
  () => props.showing,
  async (showing: boolean) => {
    if (!showing) {
      step.value = STEPS.CHOOSE_DECK
      return
    }
  }
)

function copySlides(slides: Slide[]) {
  emit('copy-slides', {
    slides: slides.map(slide => ({ ...slide, deck_id: props.deck.id })),
    deckName: state.selectedDeck?.title,
  })
}

function selectDeck(deck: EditDeck) {
  step.value = STEPS.CHOOSE_SLIDES
  state.selectedDeck = deck
}
</script>
